
import React, { useState, useEffect, Suspense } from 'react';
import dummydata from '../dummydata';
import Particle from './Particles';
import Snowfall from 'react-snowfall'
import { NavLink } from "react-router-dom";
import { useNavigate , Redirect} from "react-router-dom";
import { postAPI } from '../ApiService';
const Login_page = () => {
    const navigate = useNavigate();
    
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [passwordType, setPasswordType] = useState(true);
    const [keepLoggedIn, setKeepLoggedIn] = useState(0);
    const [emailError, setemailError] = useState();
    const [passwordError, setPasswordError] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        if(localStorage.getItem('token')){
            // navigate("/all-project");
            window.location.href = "/projects?status=active" ;
        }
    })
    
    const handleData = (e) => {
        let value = e.target.value;
        let name = e.target.name;
    
        switch (name) {
          case 'username':
            setEmail(value)
            
            break;
          case 'password':
            setPassword(value);
          
            break;
        
          default:
            break;
        }
      }

      const onUserLogin = async () => {
        setError();
        if (!email) {
            return setEmail(" *Required")
        }
        if (!password) {
            return setPasswordError(" *Required")
        }
        let data = {
            email : email,
            password : password,
            keepLoggedIn: keepLoggedIn ? 1 : 0
        }
        let res = await postAPI('/auth/login/', data)
        if(res.status === 1){
            localStorage.setItem('token', res.payload.token);
            localStorage.setItem('userDetail', JSON.stringify(res.payload))
            //navigate("/all-project");
            window.location.href = "/projects?status=active" ;
        }else{
            setError(res.message)
        }
    }
    
    useEffect(() => {
        document.title = "Sign In | Mindforce - Admin & Dashboard"
    }, []);
    return (
        <>
            <Snowfall
                color="white"
                snowflakeSpeed={"2s"}
                snowflakeCount={200} style={{
                    background: 'transparent',
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                    opacity: .4
                }} />

            <div className="auth-page-wrapper pt-5" style={{marginLeft:"-240px"}}>
                {/* <!-- auth page bg --> */}
                <div className="auth-one-bg-position auth-one-bg" >
                    <div className="bg-overlay"></div>

                    <div className="shape">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                        </svg>
                    </div>

                </div>

                {/* <!-- auth page content --> */}
                <div className="auth-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center mt-sm-5 mb-4 text-white-50">

                                    <p className="mt-3 fs-15 fw-medium">Market Research Services Companies
                                        <br /> Online Survey Sites in india</p>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}

                        <div className="row justify-content-center">
                            <div className="col-md-8 col-lg-6 col-xl-5">
                                <div className="card mt-4">

                                    <div className="card-body p-4">
                                        <div className="text-center mt-2">
                                            <div className='mb-2'>
                                                <a href="/" className="d-inline-block auth-logo">
                                                    <img src="/assets/images/logo-big.png" alt="" style={{ width: "100%", height: "70px" }} />
                                                </a>
                                            </div>
                                            <p className="text-muted">Sign in to continue</p>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <p className='errorMessage'>{error}</p>
                                                <div className="mb-3">
                                                    <label htmlFor="username" className="form-label">Username <span className='errorMessage'> {emailError}</span></label>
                                                    <input type="text" className="form-control" id="username" name="username" placeholder="Enter username" value={email} onChange={(e)=>handleData(e)}/>
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <a href="" className="text-muted">Forgot password?</a>
                                                    </div>
                                                    <label className="form-label" htmlFor="password-input">Password <span className='errorMessage'> {passwordError}</span></label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <input type={passwordType ? 'password':'text'} className="form-control pe-5 password-input" placeholder="Enter password" name="password" id="password-input" value={password} onChange={(e)=>handleData(e)}  />
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon" onClick={() => setPasswordType(!passwordType)}><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" value="" id="auth-remember-check" onChange={() => setKeepLoggedIn(!keepLoggedIn)} />
                                                    <label className="form-check-label" htmlFor="auth-remember-check">Remember me</label>
                                                </div>

                                                <div className="mt-4">
                                                    <button className="btn btn-success w-100"  onClick={()=>onUserLogin()} >Sign In</button>

                                                </div>
                                        </div>
                                    </div>
                                    {/* <!-- end card body --> */}
                                </div>
                                {/* <!-- end card --> */}



                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container --> */}
                </div>
                {/* <!-- end auth page content --> */}

                {/* <!-- footer --> */}
                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">&copy;
                                        Mindforce © 2023. All rights reserved.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/* <!-- end Footer --> */}
            </div>
        </>);
};

export default Login_page;
